import {
  Account,
  AccountBalance,
  ProfitableDaysResult,
  Program,
  WithdrawRulesResponse,
} from '@monorepo/types';

/**
 * Widget type identifiers
 */
export enum WidgetType {
  ProfitableDays = 'ProfitableDays',
  InactiveDays = 'InactiveDays',
  MaxLoss = 'MaxLoss',
  DailyLimit = 'DailyLimit',
  Payout = 'Payout',
  EODTrailingLevel = 'EODTrailingLevel',
  ConsistencyRule = 'ConsistencyRule',
}

/**
 * Widget props union type covering all possible widget prop combinations
 */
export interface ProfitableDaysWidgetProps {
  account?: Account;
  accountBalance?: AccountBalance;
  program: Program | undefined | null;
  profitableDays: ProfitableDaysResult | null | undefined;
}

export interface InactiveDaysWidgetProps {
  account?: Account;
  accountBalance?: AccountBalance;
  program: Program | undefined | null;
}

export interface MaxLossWidgetProps {
  account?: Account;
  accountBalance?: AccountBalance;
  program: Program | undefined | null;
}

export interface DailyLimitWidgetProps {
  account?: Account;
  accountBalance?: AccountBalance;
  program: Program | undefined | null;
}

export interface PayoutWidgetProps {
  account?: Account;
  eligibilityData: WithdrawRulesResponse | undefined;
}

export interface EODTrailingLevelWidgetProps {
  account?: Account;
  accountBalance?: AccountBalance;
  program: Program | undefined | null;
}

export interface ConsistencyRuleWidgetProps {
  account?: Account;
  accountBalance?: AccountBalance;
  program: Program | undefined | null;
}

export type WidgetProps =
  | ProfitableDaysWidgetProps
  | InactiveDaysWidgetProps
  | MaxLossWidgetProps
  | DailyLimitWidgetProps
  | PayoutWidgetProps
  | EODTrailingLevelWidgetProps
  | ConsistencyRuleWidgetProps;

/**
 * Widget configuration
 */
export interface WidgetConfig {
  type: WidgetType;
  props: WidgetProps;
  enabled?: boolean;
  order?: number;
}

/**
 * Widget manager hook result
 */
export interface WidgetManagerResult {
  widgets: WidgetConfig[];
  isEmpty: boolean;
  error?: string | null;
  hasWidgets: boolean;
}

/**
 * Widget data dependencies interface for strategies
 */
export interface WidgetDataDependencies {
  account?: Account;
  accountBalance?: AccountBalance;
  program: Program | undefined | null;
  eligibilityData: WithdrawRulesResponse | undefined;
  profitableDays: ProfitableDaysResult | null | undefined;
}

/**
 * Widget strategy interface
 */
export interface WidgetStrategy {
  getWidgetConfigs(data: WidgetDataDependencies): WidgetConfig[];
}
